import script from "./StepChooseRole.vue?vue&type=script&setup=true&lang=js"
export * from "./StepChooseRole.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__